export enum EParkingType {
  good = 'good',
  bad = 'bad',
}
